import * as React from 'react';
import type {
  ComparisonCellValue,
  ComparisonRowDef,
  TextCellValue,
  BadgeListCellValue,
  DualTextCellValue,
} from '../types';
import { TextCell, DualTextCell, BadgeListCell } from './cells';

interface CellContentProps {
  row: ComparisonRowDef;
  value: ComparisonCellValue | undefined;
}

export const CellContent: React.FC<CellContentProps> = ({ row, value }) => {
  if (!value) return null;

  switch (row.type) {
    case 'text': {
      const v = value as TextCellValue;
      if ('badges' in value || 'primary' in value) {
        console.error(
          `[CellContent] Value shape does not match row type "text" for key "${row.key}"`,
        );
      }
      return (
        <TextCell
          value={v}
          clamp={row.clamp !== false}
          html={row.html === true}
        />
      );
    }
    case 'badgeList': {
      const v = value as BadgeListCellValue;
      if ('text' in value || 'primary' in value) {
        console.error(
          `[CellContent] Value shape does not match row type "badgeList" for key "${row.key}"`,
        );
      }
      return (
        <BadgeListCell
          value={v}
          rowDef={row as Extract<ComparisonRowDef, { type: 'badgeList' }>}
        />
      );
    }
    case 'dualText': {
      const v = value as DualTextCellValue;
      if ('text' in value || 'badges' in value) {
        console.error(
          `[CellContent] Value shape does not match row type "dualText" for key "${row.key}"`,
        );
      }
      return <DualTextCell value={v} />;
    }
    default: {
      console.error(
        `[CellContent] Unknown row type "${(row as ComparisonRowDef).type}" for key "${(row as ComparisonRowDef).key}"`,
      );
      return null;
    }
  }
};

CellContent.displayName = 'CellContent';
